import { API_BASE_URL } from '../../../../../common/utils/commonUrl';
import http from '../../../../../common/utils/http';
import * as RoutePathConstants from '../../../../../constants/RoutePathConstants';

export default {
  data () {
    return {
      memberDetails: {},
      qrCode: null
    }
  },
  methods: {
    getMemberDetails () {
      http
        .get(`${API_BASE_URL}/api/wxoa/member/member/getUserMemberDetails`)
        .then(res => {
          this.memberDetails = res.data.data;
          this.qrCode = `${API_BASE_URL}/api/qr/generate?content=${res.data.data.id
            }&X-Authorization=${localStorage.getItem("token")}`
        });
    },
    goToMyCoupon () {
      this.$router.push({
        path: RoutePathConstants.MY_COUPON
      });
    }
  },

  mounted () {
    this.getMemberDetails();
  }
};



// WEBPACK FOOTER //
// ./src/pages/wx-member/member/views/components/my-stored-value-record.js